<template>
  <div class="search_bar_container">
    <input v-model="keySearch" class="search_input" type="text" placeholder="Search for an Event, Hub, or News" @keyup.enter="search" @focus="autofillEvent()" @input="autoSearch">
    <div class="search_action">
      <img class="lazyload" :data-src="contentCloudFront('/assets/search_bar/search_icon.png')" width="19" height="19" @click="search()">
    </div>
  </div>
</template>

<script>
import { component } from '../../mixins/component';
import { EventBus, SEARCH_HANDLE_SEARCH, SEARCH_UPDATE_QUERY } from '../../event-bus';

export default {
  components: {},
  mixins: [component],
  props: {
    onSearch: {
      type: Function,
      default: () => {},
    },
    onAutofillEvent: {
      type: Function,
      default: () => {},
    },
    onAutoSearch: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      keySearch: '',
    };
  },
  created() {
    EventBus.$on(SEARCH_UPDATE_QUERY, (keySearch) => {
      if (window.location.href.includes(this.appConfig.baseUrl + '/search')) {
        this.keySearch = keySearch;
      }
    });
  },
  beforeDestroy() {
    EventBus.$off(SEARCH_UPDATE_QUERY);
  },
  methods: {
    search() {
      if (window.location.href.includes(this.appConfig.baseUrl + '/search')) {
        EventBus.$emit(SEARCH_HANDLE_SEARCH, this.keySearch);
      } else {
        if (!this.keySearch) {
          this.onAutofillEvent();
        } else {
          this.onSearch(this.keySearch);
        }
      }
    },
    autofillEvent() {
      if (!this.keySearch) {
        this.onAutofillEvent();
      }
    },
    autoSearch() {
      this.onAutoSearch(this.keySearch);
    },
  },
};
</script>
